export const QUICK_SETUP_PULSE_EVENT = "meetocto:pulse-quick-setup";
export const QUICK_SETUP_PULSE_STORAGE_KEY = "meetocto.pulseQuickSetupUntil";
export const QUICK_SETUP_PULSE_MS = 4500;
export const QUICK_SETUP_HINT_TEXT =
  "Finish your profile before creating an event.";
export const EVENT_CREATE_LIST_PATH = "/admin/events/create/list";

let pulseUntil = 0;

const readStoredUntil = () => {
  try {
    const stored = window.sessionStorage.getItem(QUICK_SETUP_PULSE_STORAGE_KEY);
    const parsed = stored ? Number(stored) : 0;
    return Number.isFinite(parsed) ? parsed : 0;
  } catch (error) {
    return 0;
  }
};

const writeStoredUntil = (until) => {
  try {
    if (until > Date.now()) {
      window.sessionStorage.setItem(
        QUICK_SETUP_PULSE_STORAGE_KEY,
        String(until)
      );
    } else {
      window.sessionStorage.removeItem(QUICK_SETUP_PULSE_STORAGE_KEY);
    }
  } catch (error) {
    // ignore storage failures
  }
};

export const isMobileQuickSetupViewport = () =>
  typeof window !== "undefined" &&
  window.matchMedia("(max-width: 767.98px)").matches;

export const isEventCreateListPath = (pathname = "") =>
  pathname.includes("/admin/events/create/list");

export const getRemainingQuickSetupPulseMs = () => {
  if (typeof window === "undefined") {
    return 0;
  }

  const until = Math.max(pulseUntil, readStoredUntil());
  return Math.max(0, until - Date.now());
};

export const clearQuickSetupPulse = () => {
  pulseUntil = 0;
  if (typeof window !== "undefined") {
    writeStoredUntil(0);
  }
};

export const requestQuickSetupPulse = () => {
  if (typeof window === "undefined") {
    return;
  }

  pulseUntil = Date.now() + QUICK_SETUP_PULSE_MS;
  writeStoredUntil(pulseUntil);
  window.dispatchEvent(new CustomEvent(QUICK_SETUP_PULSE_EVENT));
};
